import { fromBase64, toBase64 } from '@aws-sdk/util-base64'
import EventEmitter from 'events'
import protobuf from 'protobufjs'

import methods from './methods'
import json from './proto.json'

interface MethodsType {
  [key: string]: number
}

export interface MessageType {
  GPBType: number
  msgBase64: string
  version?: number
  type?: number
  timeId?: number
  index?: number
  total?: number
}

export interface DeMessage {
  method: string
  GPBType: number
  payload: any
}

/**
 * 用于暂存分包数据，分包被消费即删除
 * { method_timeId: [msgBase64-1, msgBase64-2, ...], ... }
 */
const pack: { [key: string]: Uint8Array[] } = {}

export class EncodeOrDecode extends EventEmitter {
  private root: protobuf.Root = protobuf.Root.fromJSON(json)
  private method: string = ''
  private typeClient: protobuf.Type

  constructor(method: string) {
    super()
    this.method = method
    try {
      this.typeClient = this.root.lookupType(method)
    } catch (error) {
      console.error(`RTM EncodeOrDecode: 无法找到方法类型 "${method}":`, error)
      throw new Error(`无效的方法类型: ${method}`)
    }
  }

  public static getMethod(GPBType: number): string {
    let method = ''
    Object.keys(methods).forEach((key) => {
      if ((methods as MethodsType)[key] === Number(GPBType)) {
        method = key
      }
    })
    return method
  }

  static get pack() {
    return pack
  }

  public static getGPBType(method: string): number {
    return (methods as MethodsType)[method]
  }

  public encode(payload: object): MessageType[] {
    // 验证有效负载(如可能不完整或无效)
    const errMsg = this.typeClient.verify(payload)
    if (errMsg) throw Error(errMsg)

    const message = this.typeClient.create(payload)
    const buff = this.typeClient.encode(message).finish()
    const buffer = this.slice(buff)
    return this.merge(buffer)
  }

  private slice(buff: Uint8Array) {
    const size = 8192
    const buffer = []
    // 包的总个数
    let total = -1
    if (buff.length > size) {
      total = Math.ceil(buff.length / size)
      for (let i = 0; i < total; i++) {
        buffer.push(buff.slice(i * size, (i + 1) * size))
      }
    } else {
      buffer.push(buff)
    }
    return buffer
  }

  private merge(buffer: Uint8Array[]) {
    const messageArr = []
    const time = +new Date()
    for (let i = 0; i < buffer.length; i++) {
      const message: MessageType = {
        version: 3,
        type: 17,
        GPBType: (methods as MethodsType)[this.method],
        msgBase64: toBase64(buffer[i])
      }
      if (buffer.length > 1) {
        message.timeId = time
        message.index = i
        message.total = buffer.length
      }
      messageArr.push(message)
    }
    return messageArr
  }

  public decode(message: MessageType): DeMessage | undefined {
    const { GPBType, msgBase64, timeId = 0, index = 0, total = 0 } = message
    let buffer: Uint8Array | null = null
    if (total > 0) {
      const key = `${this.method}_${timeId}`
      if (!pack[key]) {
        pack[key] = []
      }
      pack[key][index] = fromBase64(msgBase64)
      // 检查是否所有分包都已接收完成，使用更安全的方式
      const receivedParts = pack[key].filter((v) => v !== undefined && v !== null)
      if (receivedParts.length === total) {
        let len: number = 0
        // 使用原始数组顺序遍历，确保顺序正确
        for (let i = 0; i < total; i++) {
          if (pack[key][i]) {
            len += pack[key][i].length
          }
        }
        const mergedArray = new Uint8Array(len)
        let currentIndex = 0
        // 按顺序合并分包
        for (let i = 0; i < total; i++) {
          if (pack[key][i]) {
            mergedArray.set(pack[key][i], currentIndex)
            currentIndex += pack[key][i].length
          }
        }
        delete pack[key]
        buffer = mergedArray
      }
    } else {
      buffer = fromBase64(msgBase64)
    }
    if (buffer) {
      try {
        const message = this.typeClient.decode(buffer)
        const payload = this.typeClient.toObject(message, {
          longs: String,
          enums: Number,
          bytes: String,
          defaults: true,
          arrays: true,
          objects: true,
          json: true
        })
        return {
          method: this.method,
          GPBType,
          payload
        }
      } catch (e) {
        console.error('信令解析失败，可能未适配此信令，信令GPBType：', GPBType)
      }
    }
  }
}
